import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    '&.Mui-selected.MuiTreeItem-content': {
      '&::before': {
        backgroundColor: idsTokens.treeView.default.color.selected.background.enabled,
      },
      '&:hover': {
        '&::before': {
          backgroundColor: idsTokens.treeView.default.color.selected.background.hover,
        },
      },
      '&.Mui-focused:active': {
        '&::before': {
          backgroundColor: idsTokens.treeView.default.color.selected.background.pressed,
        },
      },
    },
    '& >.MuiTreeItem-content:hover, & >.MuiTreeItem-content.Mui-selected': {
      '& svg': {
        color: idsTokens.treeView.default.color.text.title.enabled,
      },
    },
    '& >.Mui-selected.MuiTreeItem-content, & >.Mui-expanded.MuiTreeItem-content ': {
      backgroundColor: 'unset',
      '&.Mui-focused': {
        backgroundColor: 'unset',
      },
    },
  },
  group: {
    marginLeft: 6,
  },
  content: {
    paddingLeft: 15,
    width: 'calc(100% - 15px)',
  },
  iconContainer: {
    zIndex: 1,
    '& svg': {
      fontSize: 16.8,
      boxSizing: 'content-box',
      color: idsTokens.treeView.default.color.text.title.enabled,
    },
  },
  label: {
    paddingLeft: 2,
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%', //'calc(100% - 36px)',
    alignItems: 'flex-start',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
});
